<template>
  <b-modal :active="isModalOpen" scroll="keep" :can-cancel="false">
    <div class="card">
      <div class="card-content">
        <b-field
          :label="goalStatusText.label"
          message="This is optional, it will appear alongside the goal during standup."
        >
          <b-input
            maxlength="200"
            type="textarea"
            v-model="newGoalStatusDetailText"
            placeholder="Ex: My dog ate my homework"
            ref="changedGoalExplanationInput"
          />
        </b-field>

          <div class="control">
            <b-button
              :disabled="newGoalStatusDetailText && newGoalStatusDetailText.length == 0"
              class="is-fullwidth-mobile u-m-r-small"
              type="is-primary"
              @click="handleSubmit(newGoalStatusDetailText)"
            >
              Add {{ goalStatusText.pastTense }} Goal Detail
            </b-button>
            <b-button
              class="is-fullwidth-mobile"
              type="is-secondary"
              @click="handleSubmit()"
            >
              Just Mark Goal {{ goalStatusText.pastTense }}
            </b-button>
          </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import * as Types from '@/constants/Types';

export default {
  name: 'GoalStatusDetailModal',

  props: {
    isModalOpen: {
      type: Boolean,
      required: true,
    },
    goalId: {
      type: String,
      required: false,
    },
    goalStatus: {
      type: Number,
      required: false,
    },
    goalStatusDetailText: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      newGoalStatusDetailText: this.goalStatusDetailText,
    };
  },

  computed: {
    goalStatusText() {
      if (this.goalStatus === Types.GOAL_MISS) {
        return {
          presentTense: 'Miss',
          pastTense: 'Missed',
          label: 'What got in your way?',
        };
      }

      if (this.goalStatus === Types.GOAL_CHANGED) {
        return {
          presentTense: 'Change',
          pastTense: 'Changed',
          label: 'What became your priority?',
        };
      }

      return {
        presentTense: '',
        pastTense: '',
      };
    },
  },

  watch: {
    goalStatusDetailText(newValue) {
      this.newGoalStatusDetailText = newValue;
    },
  },

  methods: {
    handleSubmit(goalDetailText = null) {
      this.$emit('modal-close', {
        goalId: this.goalId,
        goalStatus: this.goalStatus,
        goalStatusExplanation: goalDetailText,
      });
      this.newGoalStatusDetailText = '';
    },
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 768px), print {
  .button.is-fullwidth-mobile {
    display: flex;
    width: 100%;
    margin-top: 1rem;
  }
}
</style>
